import Swiper, { Navigation, Pagination, Mousewheel } from "swiper";
// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/mousewheel";

$(".swiper-gallery").each(function () {
  const data = JSON.parse($("#" + $(this)[0].id + "__config")[0].textContent);

  const breakpoint = data.breakpoint;
  const swiperId = $(this)[0].id;

  if ($(this).parent().parent().hasClass("amdg-column")) {
    $(this).parent().parent().css({ width: "100%", overflow: "hidden" });
  }

  // const pagination = document.getElementById("amdg-swiper__pagination");

  // init Swiper:
  const swiper = new Swiper(`#${swiperId} .amdg-swiper-gallery`, {
    // configure Swiper to use modules
    modules: [Navigation, Pagination],
    spaceBetween: data.mobileSpaceBetween,
    slidesPerView: 1,
    slidesPerGroup: 1,
    // pagination: {
    //   el: ".swiper-pagination",
    //   clickable: true,
    // },
    breakpoints: {
      // when window width is >=
      [String(breakpoint)]: {
        slidesPerView: data.slidesPerView,
        slidesPerGroup: data.slidesPerView,
        spaceBetween: data.spaceBetween,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
});

$(".swiper-row").each(function () {
  const data = JSON.parse($("#" + $(this)[0].id + "__config")[0].textContent);

  const breakpoint = data.breakpoint;
  const swiperId = $(this)[0].id;

  $(`#${swiperId} .amdg-column`).addClass("swiper-slide");

  const swiperOptions = {
    // configure Swiper to use modules
    modules: [Navigation, Pagination, Mousewheel],
    spaceBetween: data.mobileSpaceBetween,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerView: 1.1,
    centeredSlides: true,
    loop: true,
    // pagination: {
    //   el: ".swiper-pagination",
    //   clickable: true,
    // },
    breakpoints: {
      // when window width is >=
      [String(breakpoint)]: {
        slidesPerView: data.slidesPerView,
        slidesPerGroup: data.slidesPerView,
        spaceBetween: data.spaceBetween,
        centeredSlides: false,
        centeredSlidesBounds: false,
        loop: $('.swiper-slide').length > data.slidesPerView ? true : false,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  }
  // init Swiper:
  let swiper = new Swiper(`#${swiperId}`, swiperOptions);

});
